(function() {

  // Function which syncs models from the `sourceCollection` 
  // into the `destCollection` based on events
  function syncInto(sourceCollection, destCollection) {
    destCollection.listenTo(sourceCollection, 'add', function(model) {
      this.add(model);
    });
    destCollection.listenTo(sourceCollection, 'remove', function(model) {
      this.remove(model);
    });
    destCollection.listenTo(sourceCollection, 'reset', function(coll) {
      this.reset(coll.models);
    });
  }


  zfrespond.views.RespondAppView = Backbone.View.extend({

    template: ZFRESPOND_JST['respond.respond_app'],

    className: "respond-app-view",

    initialize: function(options) {
      var me = this;

      this.mobile = options.mobile;

      this._currentScreen = 'welcome';
      this._inProgressAssetPrecursors = {};

      //// Make subviews

      this.welcomeView = new zfrespond.views.WelcomeView({
        model: this.model,
        campaign: options.campaign,
        loggedInUserEmail: options.loggedInUserEmail,
        loggedInUserName: options.loggedInUserName,
        autoplay: options.autoplay
      });

      // This collection should have *all* responses the user makes
      var allResponses = new zfrespond.models.Responses();

      var RespondView = this.mobile ? 
              zfrespond.views.RespondFullpageView : zfrespond.views.RespondView;

      this.fieldViews = options.fields.map(function(fieldModel){
        // These collections should contain only the responses
        // for this field
        var responses = new zfrespond.models.Responses();
        syncInto(responses, allResponses);
        return new RespondView({ 
            model: fieldModel,
            responses: responses,
            mediaCollector: me.model
          });

      });

      this.questionsHeaderFixed = new zfrespond.views.QuestionsHeaderView({
        model: this.model,
        fields: options.fields,
        allResponses: allResponses,
        fixed: true
      });

      //// Listen to subviews

      this.listenTo(this.welcomeView,'goto:main', this.scrollToMain);
      this.listenTo(this.questionsHeaderFixed,'goto:welcome', this.scrollToWelcome);
      
      _.each(this.fieldViews, function(view) {
        me.listenTo(view, 'expanded', me.onExpandedRespondView);
        me.listenTo(view, 'unexpanded', me.onUnexpandedRespondView);
        me.listenTo(view, 'push-view', me.pushToViewStack);
        me.listenTo(view, 'upload-started', me.onUploadStarted);
      });

      if (!this.mobile) {
        // On desktop, resize content on window resize
        $(window).on('resize.respond-app', function() {
          me.sizeWelcomeSection();
          me.sizeMainSection();
        });       
      } else {
        // On mobile, only resize on orientation change
        $(window).on('orientationchange.respond-app', function() {
          me.sizeWelcomeSection();
          me.sizeMainSection();
        });     
      }

    },

    remove: function() {
      $(window).off('.respond-app');
      zfrespond.views.RespondAppView.__super__.remove.call(this);
    },

    render: function() {
      this.$el.html(this.template({ }));

      this.$('.welcome-section').append(this.welcomeView.$el);
      // We have to render the welcome view *after* we add it to the DOM
      // because vide
      this.welcomeView.render(); 

      this.$el.append(this.questionsHeaderFixed.render().$el);

      _.each(this.fieldViews, function(fieldView) {
        this.$('.questions-container').append(fieldView.render().$el);
      });

      this.sizeWelcomeSection();
      this.sizeMainSection();

      this.showCurrentScreen();

      this.renderGlobalUploadInProgress();

      return this;
    },

    renderGlobalUploadInProgress: function() {

      if (this.isAnyUploadInProgress()) {

        this.$('.dont-leave').show();

        // Animate the progress bar
        var memo = { loaded:0, total: 0 };
        var progressData = _.reduce(this._inProgressAssetPrecursors, function(a, b) {
          return { loaded: a.loaded + b.loaded, total: a.total + b.total };
        }, memo);
        var progressPercent = parseFloat(progressData.loaded) / parseFloat(progressData.total);
        var progressWrapWidth = this.$('.dont-leave .progress-wrap').width();

        var $progressBar = this.$('.dont-leave .progress-bar');
        var newLeftPos = progressPercent * progressWrapWidth;

        $progressBar.stop();

        if (newLeftPos < parseInt($progressBar.css('left'))) {
          // If the progress bar is going *backwards* do it now
          $progressBar.css({ left: newLeftPos });
        } else {
          // If the progress bar is progressing normally animate it!
          $progressBar.animate({
            left: newLeftPos
          }, 4000);
        }
        // End animate


      } else {
        this.$('.dont-leave').hide();
      }

    },

    sizeWelcomeSection: function() {
      this.$('.welcome-section').css({
        'min-height': window.innerHeight - 60 + 'px'
      });
    },

    sizeMainSection: function() {
      this.$('.main-section').css({
        'min-height': window.innerHeight - 60 + 'px'
      });
    },
    
    sizeQuestionsPadding: function() {
      this.questionsHeaderFixed.$el.show();
      this.$('.questions-section').css(
        'padding-top', this.questionsHeaderFixed.$el.height() + 20
      );
      this.questionsHeaderFixed.$el.hide();
    },

    showCurrentScreen: function() {
      if (this._currentScreen == 'welcome') {
        this.questionsHeaderFixed.$el.hide();
        this.$('.welcome-section').show(); 
        this.$('.main-section').hide();
      } else if (this._currentScreen == 'main') {
        this.$('.main-section').show();
        this.$('.welcome-section').hide(); 
        this.questionsHeaderFixed.$el.show();
      }
      window.scrollTo(0,0);
    },

    scrollToMain: function() {
      var me = this;
      this.$('.main-section').show();
      this.sizeQuestionsPadding();
      this._currentScreen = 'main';
      $('html, body').animate({
        scrollTop: this.$('.main-section').offset().top
      }, 400, undefined, function(){
        me.showCurrentScreen();
      });
    },
    
    scrollToWelcome: function() {
      var me = this;
      var initialScrollPos = $(window).scrollTop();
      this.$('.welcome-section').show();
      window.scrollTo(0, initialScrollPos + this.$('.welcome-section').outerHeight());
      this._currentScreen = 'welcome';
      $('html, body').animate({
        scrollTop: 0
      }, 400, undefined, function(){
        me.showCurrentScreen();
      });
    },

    isAnyUploadInProgress: function() {
      return _.size(this._inProgressAssetPrecursors) > 0;
    },

    pushToViewStack: function(view) {
      var $viewStackItem = $('<div class="view-stack-item"></div>');

      $viewStackItem.css({
        position: 'fixed',
        left:0,
        top:0,
        right:0,
        bottom:0,
        'z-index':100
      });

      $('body').append($viewStackItem);


      view.$el.css({
        'position': 'absolute',
        'top': 0,
        'left': $viewStackItem.width(),
        'width': '100%',
        'bottom': 0,
        'box-sizing': 'border-box',
        'z-index': 101
      });

      $viewStackItem.append(view.$el);

      view.$el.animate({ left: 0 }, 150);

      this.listenToOnce(view, 'exit', function() {
        view.$el.animate({
          left: $viewStackItem.width()

        }, 150, function() {
          view.remove();
          $viewStackItem.remove();

        }); 

      });

    },


    // Internal event handlers

    onUploadStarted: function(assetPrecursor) {

      var progressData = {loaded:0, total:1}; // Start at `1` so we can divide by this number and not get NaN
      this._inProgressAssetPrecursors[assetPrecursor.cid] = progressData;
      this.renderGlobalUploadInProgress();

      this.listenTo(assetPrecursor, 'progress', function(percent, data) {
        progressData.loaded = data.loaded;
        progressData.total = data.total;
        this.renderGlobalUploadInProgress();
      });

      this.listenToOnce(assetPrecursor, 'ended', function() {
        delete this._inProgressAssetPrecursors[assetPrecursor.cid];
        this.renderGlobalUploadInProgress();
      });

    },

    onExpandedRespondView: function(expandedView, options) {
      var neighborsShould = options.neighborsShould;
      var isolate = options.isolate;
      var headerHeight;
      var $placeholder;

      if (isolate) {
        $placeholder = $('<div class="placeholder"></div>');
        $placeholder.css({
          'height': expandedView.$el.height(),
          'width': '100%'
        });
        $placeholder.insertAfter(expandedView.$el);
        expandedView.$placeholder = $placeholder;
              
        $('.questions-header-view.fixed').css({
          visibility:'hidden'
        });
        headerHeight = expandedView.$('.header').show().height();
        expandedView.$('.header').css({
          visibility: 'hidden'
        });
        expandedView.$el.css({
          'position': 'fixed',
          'z-index': 10,
          'left': 0,
          'top': expandedView.$el.offset().top - $(window).scrollTop() - headerHeight,
          'right': 0,
          'bottom': $(window).height() - expandedView.$el.offset().top - $(window).scrollTop() - expandedView.$el.outerHeight(),
          'overflow': 'hidden'
        });
        expandedView.$('.field-body').show();
        expandedView.$el.animate({
          'top': 0,
          'bottom': 0
        }, undefined, undefined, function(){
          expandedView.$('.header').css({
            visibility: 'visible'
          }).hide().fadeIn(60);
          expandedView.$el.css('overflow', 'auto');
        });
        expandedView.$el.addClass('expanded');
      }

      _.each(this.fieldViews, function(view) {
        if (_.isEqual(expandedView, view)) {
          return; // Skip this one
        }

        if (neighborsShould === 'unexpand') {
          if (view.isExpanded()) {
            view.unexpand();
          }          
        } else if (neighborsShould === 'contract') {
          if (!view.isContracted()) {
            view.contract();
          }
        }


      });
    },

    onUnexpandedRespondView: function(unexpandedView, options) {

      var opts = options || {};
      var neighborsShould = opts.neighborsShould;
      var unisolate = opts.unisolate;
      
      if (neighborsShould === 'uncontract') {
        // Un-contract all of the neighbors 
        _.each(this.fieldViews, function(view) {
          if (_.isEqual(unexpandedView, view)) {
            return; // Skip this one
          }
          if (view.isContracted()) {
            view.uncontract();
          }
        });

      }

      if (unisolate) {
        $('.questions-header-view.fixed').css({
          visibility:''
        });

        unexpandedView.$el.css({
          'position': 'relative',
          'left':'',
          'top':'',
          'right':'',
          'bottom':'',
          'z-index':''
        });
        
        unexpandedView.$el.removeClass('expanded');
        unexpandedView.$('.header').hide();
        var jumpTo = (
          unexpandedView.$el.offset().top -
          $('.questions-header-view.fixed').height() -
          20
        );
        window.scrollTo(0, jumpTo);
        unexpandedView.$('.field-body').slideUp(400);
        unexpandedView.$placeholder.remove();

      }

      if (neighborsShould === 'expandnext') {
        // Expand the next neighbor

        var index = _.indexOf(_.pluck(this.fieldViews,'cid'), unexpandedView.cid);
        var nextIndex = index + 1;
        if (this.fieldViews.length !== nextIndex) {
          this.fieldViews[nextIndex].expand();
        }

      }
    }


  });


}());
